import { ExpeirmentNodeProps } from 'business/models/CustomModels';
import React from 'react';
import TreeNode from './TreeNode';

export default function ProteinFormulationNode(props: ExpeirmentNodeProps) {
  const node = props.data;

  const allProps = {
    ...props,
    link: `/proteins`,
  };

  function onDragStart(e, pfTreeNodeid) {
    e.dataTransfer.setData('drag_type', 'PF_NODE');
    e.dataTransfer.setData('id', pfTreeNodeid);
  }

  return (
    <TreeNode
      key={node.id}
      {...allProps}
      draggable={true}
      onDragStart={(e) => onDragStart(e, node.id)}
    />
  );
}
